import { render, staticRenderFns } from "./UnifiedSearch.vue?vue&type=template&id=71ddcd20&scoped=true&"
import script from "./UnifiedSearch.vue?vue&type=script&lang=js&"
export * from "./UnifiedSearch.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedSearch.vue?vue&type=style&index=0&id=71ddcd20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ddcd20",
  null
  
)

export default component.exports